import { Upload, Loader2 } from "lucide-react";
import { useRef } from "react";
import { useDocumentMutaion } from "@/hooks/api/useDocmentMutation";
import { DOCUMENT_ACCEPT, DOCUMENT_ACCEPT_LABEL } from "@/utils/uploadFileTypes";
import { refetchCurrentLead } from "@/features/leads/api/useCurrentLead";
import { refetchChilds } from "@/features/leads/api/useChilds";
import { refetchCurrentChild } from "@/features/leads/api/useCurrentChild";

interface ChildDocUploadProps {
  childId?: number | string;
  stageName?: string;
  childName?: string;
}

export function ChildDocUpload({
  childId,
  stageName,
  childName,
}: ChildDocUploadProps) {
  const { uploadFile } = useDocumentMutaion();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file || !childId) return;

    uploadFile.mutate(
      {
        file,
        attachedTo: "child",
        attachedScope: String(childId),
        category: stageName || "General",
        name: childName ? `${childName} - ${file.name}` : file.name,
      },
      {
        onSuccess: () => {
          Promise.all([
            refetchCurrentLead(),
            refetchChilds(),
            refetchCurrentChild(),
          ]);
        },
      }
    );

    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        onChange={handleFileChange}
        accept={DOCUMENT_ACCEPT}
      />
      <div
        onClick={handleClick}
        className="bg-[#fcfcfc] border-[1.2px] border-dashed border-[var(--color-green-7)] rounded-[12px] px-4 py-2 flex gap-2 items-center justify-center shadow-sm cursor-pointer hover:bg-[#f5f7f6] transition-colors"
      >
        {uploadFile.isPending ? (
          <Loader2 className="size-5 text-[var(--color-primary)] animate-spin" />
        ) : (
          <div className="bg-[var(--color-green-1)] rounded-lg size-9 flex items-center justify-center">
            <Upload
              size={20}
              className="text-[var(--color-primary)]"
              strokeWidth={1.5}
            />
          </div>
        )}
        <div className="flex flex-col">
          <p className="text-[14px] font-normal text-[var(--color-black-8)] tracking-[-0.56px] leading-[1.35]">
            {uploadFile.isPending ? "Uploading..." : "Upload document"}
          </p>
          {!uploadFile.isPending && (
            <p className="text-[11px] text-[var(--color-text-gray)] leading-[1.3] mt-0.5">
              {DOCUMENT_ACCEPT_LABEL} — max 5MB
            </p>
          )}
        </div>
      </div>
    </>
  );
}
